import { cn } from "@/lib/utils";
import { IconChevronLeft, IconX } from "@tabler/icons-react";
import { Button } from "@/lib/components/Button/Button";

type NavigationButtonProps = {
  onClick?: () => void;
  onClose?: () => void;
  text: string;
  className?: string;
  children?: React.ReactNode;
  titleAction?: React.ReactNode;
};

export function NavigationButton({
  onClick,
  onClose,
  text,
  className,
  children,
  titleAction,
}: NavigationButtonProps) {
  return (
    <div className={cn("border-b border-grey-200 p-6", className)}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {onClick ? (
            <button
              className="-ml-1 flex cursor-pointer flex-row items-center gap-2 text-sm font-semibold text-text-primary"
              onClick={onClick}
            >
              <IconChevronLeft
                className="text-text-primary"
                width={16}
                height={16}
              />
              {text}
            </button>
          ) : (
            <span className="text-sm font-semibold text-text-primary">
              {text}
            </span>
          )}
          {titleAction}
        </div>
        <div className="flex items-center gap-2">
          {children}
          {onClose && (
            <Button
              size="iconSm"
              variant="ghost"
              onClick={onClose}
              className="-mr-3"
            >
              <IconX className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
